import { Component, inject, signal } from '@angular/core';
import { form, FormField, validate } from '@angular/forms/signals';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { isValidExternalFolderUrl } from '@app/shared/types/models/files/external-folder-link.util';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface FileExplorerExternalLinkDialogData {
  url?: string;
}
export interface FileExplorerExternalLinkDialogResult {
  url: string | null;
}

/** PROPOZYCJA — DO WERYFIKACJI: returns a link choice; the parent owns all writes. */
@Component({
  selector: 'proffeo-file-explorer-external-link-dialog',
  templateUrl: './file-explorer-external-link-dialog.component.html',
  imports: [FormField, MatDialogModule, TranslatePipe, UiDialogComponent, UiInputComponent, UiButtonComponent]
})
export class FileExplorerExternalLinkDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<FileExplorerExternalLinkDialogComponent, FileExplorerExternalLinkDialogResult>
  );
  protected readonly data = inject<FileExplorerExternalLinkDialogData>(MAT_DIALOG_DATA);
  protected readonly model = signal({ url: this.data.url ?? '' });
  protected readonly linkForm = form(this.model, path => {
    validate(path.url, ({ value }) =>
      !value().trim() || isValidExternalFolderUrl(value())
        ? undefined
        : { kind: 'url', message: 'files.explorer.external-invalid' }
    );
  });

  protected save(event?: Event): void {
    event?.preventDefault();
    if (this.linkForm().invalid()) return;
    this.dialogRef.close({ url: this.model().url.trim() || null });
  }
}
